// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  url: "https://truein.app/gotruein.dev/truein/",
  base_url: "https://truein.app/gotruein.dev/dashboard",
  node_url_v1: "https://truein.app/v1/",
  // login_type: 'local_login',
  login_type: "",
  credentials: { office_email: '9426263121', password: 'justj!@#$', check_session: '0' },
  recaptcha_site_key: "6LeUZzMtAAAAAKB-d5pFVaUJ2cEHYlu-z-Yw01af",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
